import {WdiModalAppProps} from '@/components/WdiControls';
import {ImportModalApp} from '@/components/WdiControls/WdiImport';
import download from '@/utils/download';
import {formatter} from '@/utils/request';
import {FormSpMkt} from "@/services/mkt/sp";


const ModifyMktPaymentAmountModalApp: React.FC<WdiModalAppProps> = (props: WdiModalAppProps) => {
  return (
    <>
      <ImportModalApp
        title={props.title}
        visible={props.visible}
        settingsUrl='/activityapi/spMktButtons/getModifyPaymentAmountImportSettings'
        uploadingUrl='/activityapi/spMktButtons/modifyPaymentAmount'
        onClose={props.onClose}
        onSave={props.onSave}
        clientParameters={{
          formId: props.id,
        }}
        events={{
          downloadFormSpDetailForModifyAmount: () => {
            download(FormSpMkt.Buttons.Path.DownloadModifyAmountTable, formatter({
              method: 'GET',
              body: {formId: props.id},
            }));
          },
        }}
      />
    </>
  );
};

export default ModifyMktPaymentAmountModalApp;
